"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex flex-col lg:flex-row" };
const _hoisted_2 = { class: "lg:w-1/3 lg:mr-2" };
const _hoisted_3 = { class: "text-3xl font-bold text-center mb-4" };
const _hoisted_4 = { class: "lg:w-1/3 lg:mr-2 lg:ml-2" };
const _hoisted_5 = { class: "text-3xl font-bold text-center mb-4" };
const _hoisted_6 = { class: "lg:w-1/3 lg:ml-2" };
const _hoisted_7 = { class: "text-3xl font-bold text-center mb-4" };
const vue_3 = require("vue");
const News_1 = require("../../stores/news/News");
const i18n_1 = require("../../common/i18n");
const NewsCard_vue_1 = __importDefault(require("../../components/News/NewsCard.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const newsStore_1 = require("../../stores/news/newsStore");
const vue_router_1 = require("vue-router");
const shop_1 = require("../../common/utils/shop");
exports.default = (0, vue_1.defineComponent)({
    __name: 'News',
    setup(__props) {
        const newsStore = (0, newsStore_1.useNewsStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const szgkNews = (0, vue_3.computed)(() => newsStore.news.filter((news) => {
            return news.category.includes(News_1.SZGK_NEWS_CATEGORY);
        }));
        const tgkmgNews = (0, vue_3.computed)(() => newsStore.news.filter((news) => {
            return news.category.includes(News_1.TGK_NEWS_CATEGORY) || news.category.includes(News_1.MG_NEWS_CATEGORY);
        }));
        const companyNews = (0, vue_3.computed)(() => newsStore.news.filter((news) => {
            return news.category.includes(News_1.COMPANY_NEWS_CATEGORY);
        }));
        const startDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        (0, vue_3.onBeforeMount)(async () => {
            try {
                await newsStore.getNewsByCategory(router, {});
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        (0, vue_3.watch)(i18n_1.i18n.locale, async (value) => {
            try {
                await newsStore.getNews(router, {
                    page: 1,
                    itemsPerPage: 30,
                    locale: value,
                    "order[createdDatetime]": "desc",
                    "createdDatetime[after]": startDate.value,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("company_news", "Company News", "dashboard")), 1),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(companyNews), (news) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(NewsCard_vue_1.default, {
                            key: news.id,
                            class: "mb-3",
                            news: news
                        }, null, 8, ["news"]));
                    }), 128))
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("szgk_news", "SZGK News", "dashboard")), 1),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(szgkNews), (news) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(NewsCard_vue_1.default, {
                            key: news.id,
                            class: "mb-3",
                            news: news
                        }, null, 8, ["news"]));
                    }), 128))
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                    (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("tgkmg_news", "TGK/MG News", "dashboard")), 1),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(tgkmgNews), (news) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(NewsCard_vue_1.default, {
                            key: news.id,
                            class: "mb-3",
                            news: news
                        }, null, 8, ["news"]));
                    }), 128))
                ])
            ]));
        };
    }
});
